var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 11L1.6 1.6 11 11l9.4-9.4L11 11zm0 0L1 21l10-10 10 10-10-10z","fillRule":"nonzero","stroke":"#002B38","strokeWidth":"3","fill":"none","strokeLinecap":"square"}));
}

CloseIcon.defaultProps = {"width":"22","height":"22"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
